// extracted by extract-css-chunks-webpack-plugin
module.exports = {"charity":"charity_59nIl","title":"title_ZEAmt","part_wrap":"part_wrap_6yIHu","part_1":"part_1_HuGLv","content":"content_-IgXf","part_2":"part_2_rR971"};